import type { CSSProperties } from 'react';

export const mobilePremiumTokens = {
  color: {
    background: '#060608',
    backgroundElevated: '#0b0b0e',
    surface: 'rgba(255, 252, 245, 0.045)',
    surfaceStrong: 'rgba(255, 252, 245, 0.07)',
    textPrimary: '#fff8ec',
    textSecondary: 'rgba(255, 248, 236, 0.66)',
    textMuted: 'rgba(255, 248, 236, 0.42)',
    violet: '#a78bfa',
    violetStrong: '#8b5cf6',
    green: '#68d391',
    amber: '#f5c56b',
    red: '#f87171',
    border: 'rgba(255, 248, 236, 0.11)',
    borderStrong: 'rgba(255, 248, 236, 0.18)',
  },
  radius: {
    chip: '999px',
    control: '999px',
    card: '18px',
    sheet: '28px',
  },
  shadow: {
    violetGlow: '0 0 0 1px rgba(167,139,250,0.14), 0 14px 34px rgba(0,0,0,0.24)',
    nav: '0 -12px 32px rgba(0,0,0,0.28)',
  },
} as const;

export type MobilePremiumTheme = 'dark' | 'light';

export const mobilePremiumThemeVars: Record<MobilePremiumTheme, CSSProperties> = {
  dark: {
    '--mp-bg': mobilePremiumTokens.color.background,
    '--mp-bg-elevated': mobilePremiumTokens.color.backgroundElevated,
    '--mp-surface': mobilePremiumTokens.color.surface,
    '--mp-surface-strong': mobilePremiumTokens.color.surfaceStrong,
    '--mp-text': mobilePremiumTokens.color.textPrimary,
    '--mp-text-secondary': mobilePremiumTokens.color.textSecondary,
    '--mp-text-muted': mobilePremiumTokens.color.textMuted,
    '--mp-violet': mobilePremiumTokens.color.violet,
    '--mp-violet-strong': mobilePremiumTokens.color.violetStrong,
    '--mp-green': mobilePremiumTokens.color.green,
    '--mp-amber': mobilePremiumTokens.color.amber,
    '--mp-red': mobilePremiumTokens.color.red,
    '--mp-border': mobilePremiumTokens.color.border,
    '--mp-border-strong': mobilePremiumTokens.color.borderStrong,
    '--mp-app-bg': '#060608',
    '--mp-shell-bg': 'radial-gradient(circle_at_50%_-14%,rgba(167,139,250,0.11),transparent_32%),linear-gradient(180deg,#08080b_0%,#060608_54%,#050506_100%)',
    '--mp-nav-bg': 'rgba(6,6,8,0.9)',
    '--mp-nav-shadow': mobilePremiumTokens.shadow.nav,
    '--mp-toggle-bg': 'rgba(255,252,245,0.045)',
    '--mp-toggle-active-bg': 'rgba(167,139,250,0.12)',
    '--mp-track': 'rgba(255,248,236,0.12)',
    '--mp-track-strong': 'rgba(255,248,236,0.22)',
    '--mp-chart-grid': 'rgba(255,248,236,0.1)',
    '--mp-chart-label': 'rgba(255,248,236,0.76)',
    '--mp-chart-point': '#fff8ec',
    '--mp-data-value': '#fff8ec',
    '--mp-body': '#55d6ef',
    '--mp-body-soft': 'rgba(85,214,239,0.12)',
  },
  light: {
    '--mp-bg': '#fbf7f0',
    '--mp-bg-elevated': '#fffdf8',
    '--mp-surface': 'rgba(29, 24, 40, 0.045)',
    '--mp-surface-strong': 'rgba(29, 24, 40, 0.075)',
    '--mp-text': '#18131f',
    '--mp-text-secondary': 'rgba(24, 19, 31, 0.66)',
    '--mp-text-muted': 'rgba(24, 19, 31, 0.42)',
    '--mp-violet': '#7c3aed',
    '--mp-violet-strong': '#6d28d9',
    '--mp-green': '#16a366',
    '--mp-amber': '#c88414',
    '--mp-red': '#dc3f45',
    '--mp-border': 'rgba(24, 19, 31, 0.12)',
    '--mp-border-strong': 'rgba(24, 19, 31, 0.2)',
    '--mp-app-bg': '#f1eae0',
    '--mp-shell-bg': 'radial-gradient(circle_at_50%_-12%,rgba(124,58,237,0.08),transparent_34%),linear-gradient(180deg,#fffdf8_0%,#fbf7f0_52%,#f4ede4_100%)',
    '--mp-nav-bg': 'rgba(255,253,248,0.9)',
    '--mp-nav-shadow': '0 -10px 26px rgba(24,19,31,0.08)',
    '--mp-toggle-bg': 'rgba(24,19,31,0.045)',
    '--mp-toggle-active-bg': 'rgba(109,40,217,0.18)',
    '--mp-track': 'rgba(24,19,31,0.14)',
    '--mp-track-strong': 'rgba(24,19,31,0.28)',
    '--mp-chart-grid': 'rgba(24,19,31,0.16)',
    '--mp-chart-label': 'rgba(24,19,31,0.74)',
    '--mp-chart-point': '#4b3e5b',
    '--mp-data-value': '#18131f',
    '--mp-body': '#087f96',
    '--mp-body-soft': 'rgba(8,127,150,0.14)',
  },
};

export const mobilePremiumCssVars = mobilePremiumThemeVars.dark;
